import axios from 'axios';

export default {
  state: {
    basket: {},
    basket_items: [],
    loading: false,
    error: null,
    basketLoaded: false,
    basketLoading: false
  },
  mutations: {
    SET_BASKET(state, basket) {
      state.basket = basket.data.item;
      state.basket_items = basket.data.items;
      state.basketLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    DEL_BASKET_ITEM(state, id) {

      for (let i in state.basket_items) {
        if (state.basket_items[i].id == id)
          state.basket_items[i].delete = true
      }

    },
    SET_BASKET_LOADING(state, status) {
      state.basketLoading = status;
    },
    SET_BASKET_ERROR(state, error) {
      state.basketError = error;
    },
    UNSET_BASKET(state) {
      state.basketLoaded = false;
      state.basketLoading = false;
      state.basket_items = [];
      state.basket = {};
    },
  },
  actions: {
    async fetchBasket({ commit, state }, reload=false) {
      if (!reload)
      commit('UNSET_BASKET');
      try {
        commit('SET_BASKET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/basket/');
        commit('SET_BASKET', response.data);
        commit('SET_BASKET_ERROR', null);
      } catch (error) {
        commit('SET_BASKET_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching basket:', error);
      } finally {
        commit('SET_BASKET_LOADING', false);
      }
    },
    async removeFromCart({ commit, state, dispatch }, id) {

      try {
        commit('DEL_BASKET_ITEM', id);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.post('api/basket/remove/', {id:id},
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.data) {
          dispatch('fetchBasket', true);
          dispatch('fetchCounterData', true);
        }

        commit('SET_BASKET_ERROR', null);
      } catch (error) {
        commit('SET_BASKET_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching basket:', error);
      } finally {
        commit('SET_BASKET_LOADING', false);
      }
    },
    async setQuantity({ commit, state, dispatch }, {id, quantity}) {

      try {
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.post('api/basket/change/', {id:id, quantity:quantity},
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.data) {
          dispatch('fetchBasket', true);
          dispatch('fetchCounterData', true);
        }

        commit('SET_BASKET_ERROR', null);
      } catch (error) {
        commit('SET_BASKET_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching basket:', error);
      } finally {
        commit('SET_BASKET_LOADING', false);
      }
    }
  },
  getters: {
    basket: state => state.basket,
    basket_items: state => state.basket_items,
    basketLoading: state => state.basketLoading,
    basketError: state => state.basketError,
    basketLoaded: state => state.basketLoaded
  }
}